import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";

moment.locale("es");

const TIPOS_LABEL = {
  I: "I - Ingreso",
  P: "P - Pago",
  E: "E - Egreso",
  N: "N - Nómina",
  T: "T - Traslado",
};

const reporteXmlPdf = (values) => {
  const xmls = values.xmls || [];
  const totales = values.totales || {};

  const filtros = [
    [
      { text: "Periodo:", style: "subheader" },
      {
        text: `${moment(values.fechaInicio).locale("es").format("LL")} al ${moment(
          values.fechaFin
        )
          .locale("es")
          .format("LL")}`,
        style: "textoChico",
      },
    ],
    [
      { text: "Tipo:", style: "subheader" },
      {
        text: values.filtroTipo
          ? TIPOS_LABEL[values.filtroTipo] || values.filtroTipo
          : "Todos",
        style: "textoChico",
      },
    ],
  ];

  const totalesBody = [
    [
      { text: "Total", style: "tituloTabla" },
      { text: "Contabilizadas", style: "tituloTabla" },
      { text: "No Contabilizadas", style: "tituloTabla" },
      { text: "Canceladas", style: "tituloTabla" },
      { text: "Pendientes", style: "tituloTabla" },
      { text: "Monto Total", style: "tituloTabla" },
      { text: "Monto Contabilizado", style: "tituloTabla" },
      { text: "Monto Faltante", style: "tituloTabla" },
    ],
    [
      { text: totales.total || 0, style: "textoTabla", alignment: "center" },
      { text: totales.contabilizadas || 0, style: "textoTabla", alignment: "center" },
      { text: totales.noContabilizadas || 0, style: "textoTabla", alignment: "center" },
      { text: totales.canceladas || 0, style: "textoTabla", alignment: "center" },
      { text: totales.pendientes || 0, style: "textoTabla", alignment: "center" },
      {
        text: dineroDisabledMask(totales.montoTotal || 0),
        style: "textoTabla",
        alignment: "right",
      },
      {
        text: dineroDisabledMask(totales.montoContabilizado || 0),
        style: "textoTabla",
        alignment: "right",
      },
      {
        text: dineroDisabledMask(totales.montoFaltante || 0),
        style: "textoTabla",
        alignment: "right",
      },
    ],
  ];

  const tablaBody = [
    [
      { text: "Fecha", style: "tituloTabla" },
      { text: "Tipo", style: "tituloTabla" },
      { text: "Serie", style: "tituloTabla" },
      { text: "Folio", style: "tituloTabla" },
      { text: "Emisor", style: "tituloTabla" },
      { text: "Receptor", style: "tituloTabla" },
      { text: "Subtotal", style: "tituloTabla" },
      { text: "Total", style: "tituloTabla" },
      { text: "Estado", style: "tituloTabla" },
      { text: "Contab.", style: "tituloTabla" },
    ],
    ...xmls.map((x) => [
      {
        text: x.fecha ? moment(x.fecha).format("DD/MM/YYYY") : "",
        style: "textoTabla",
      },
      {
        text: TIPOS_LABEL[x.tipoDeComprobante] || x.tipoDeComprobante || "",
        style: "textoTabla",
      },
      { text: x.serie || "", style: "textoTabla" },
      { text: x.folio || "", style: "textoTabla" },
      {
        text: `${x.emisorRfc || ""}\n${x.emisorNombre || ""}`,
        style: "textoTabla",
      },
      {
        text: `${x.receptorRfc || ""}\n${x.receptorNombre || ""}`,
        style: "textoTabla",
      },
      {
        text: dineroDisabledMask(x.subtotal || 0),
        style: "textoTabla",
        alignment: "right",
      },
      {
        text: dineroDisabledMask(x.total || 0),
        style: "textoTabla",
        alignment: "right",
      },
      {
        text: x.estado === 0 ? "Cancelada" : "Vigente",
        style: "textoTabla",
        alignment: "center",
      },
      {
        text: x.contabilizada === 2 ? "Sí" : "No",
        style: "textoTabla",
        alignment: "center",
      },
    ]),
  ];

  return {
    pageOrientation: "landscape",
    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 40],
    content: [
      { text: "REPORTE DE XMLs", style: "tableHeaderIzquierda", margin: [0, 0, 0, 10] },
      { text: "Datos de filtrado:" },
      {
        style: "tableExample",
        table: {
          widths: ["15%", "85%"],
          layout: { defaultBorder: false },
          body: filtros,
        },
      },
      { text: "Totales:", margin: [0, 5, 0, 0] },
      {
        style: "tableExample",
        table: {
          widths: ["10%", "12%", "13%", "11%", "11%", "13%", "15%", "15%"],
          body: totalesBody,
        },
      },
      { text: "Detalle de XMLs:", margin: [0, 5, 0, 5] },
      {
        style: "tableExample",
        table: {
          widths: ["8%", "10%", "5%", "5%", "18%", "18%", "8%", "8%", "8%", "6%"],
          headerRows: 1,
          body: tablaBody,
        },
      },
    ],
    styles: {
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tableHeaderIzquierda: { bold: true, fontSize: 14, color: "black", alignment: "center" },
      textoChico: { fontSize: 8 },
      tituloTabla: {
        fontSize: 7,
        bold: true,
        fillColor: "#cccccc",
        alignment: "center",
      },
      textoTabla: { fontSize: 7 },
    },
  };
};

export default reporteXmlPdf;
